export default function DashboardHeader() {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm font-medium uppercase tracking-wide text-sky-600">
        Student Housing Project
      </p>
      <h1 className="text-3xl font-bold text-slate-900">
        Wendy Chen Project
      </h1>
      <p className="max-w-3xl text-sm leading-6 text-slate-600">
        This dashboard analyzes housing demand, supply, occupancy,
         and waitlists across academic terms and student groups using data stored in PostgreSQL, 
         and it was built with TypeScript, Next.js, and Tailwind CSS.
      </p>
    </div>
  );
}
